@for (message of messages$(); track index; let index = $index) {
  <div [class]="messageClasses$()[index]">
    @if (icons$()[index]) {
      <sol-icon [name]="icons$()[index]" />
    }
    <div class="sol-form-message-text">
      {{ message.text | translate }}
    </div>
  </div>
}
